import React from 'react';
import ReactDOM from 'react-dom';
import { css } from '@emotion/css';
import Tooltip from 'rc-tooltip';
import { ocean_blue, dark_grey_blue, dark_grey_blue_10, color_shades_dark } from '../../constants/colors';
import OverflowMenu, { OverflowOption } from './overflowMenu/OverflowMenu';

interface LargeOverflowMenuProps {
    isActive?: boolean
    onOptionSelected?: (optionName: string, event?: any) => void
    options: OverflowOption[]
    icon?: string
    hoverIcon?: string
    className?: string
}
interface LargeOverflowMenuState {
    isActive: boolean
    menuPosition?: React.CSSProperties
}


const containerStyle = css`
    position: relative;
`
class LargeOverflowMenu extends React.Component<LargeOverflowMenuProps, LargeOverflowMenuState> {
    componentWillMount() {
        this.setState({
            ...this.state,
            isActive: false
        })
    }

    componentDidUpdate(prevProps: LargeOverflowMenuProps) {
        if (prevProps.isActive != this.props.isActive) {
            this.setState({
                ...this.state,
                isActive: this.props.isActive
            });
        }
    }

    getMenuPosition(target: HTMLElement): React.CSSProperties {
        const rect = target.getBoundingClientRect();
        const menuWidth = 320;
        const viewportPadding = 16;
        const menuOffset = 12;
        const left = Math.max(viewportPadding, Math.min(window.innerWidth - menuWidth - viewportPadding, rect.right - menuWidth));
        const availableBelow = window.innerHeight - rect.bottom - viewportPadding;
        const availableAbove = rect.top - viewportPadding;
        const shouldOpenUp = availableBelow < 260 && availableAbove > availableBelow;

        return {
            position: 'fixed',
            left,
            ...(shouldOpenUp
                ? { bottom: window.innerHeight - rect.top + menuOffset, maxHeight: Math.max(0, availableAbove - menuOffset) }
                : { top: rect.bottom + menuOffset, maxHeight: Math.max(0, availableBelow - menuOffset) }),
            overflowY: 'auto',
            zIndex: 1000
        };
    }

    handleClick(e: React.MouseEvent<HTMLElement>) {
        e.stopPropagation();
        this.setState({
            ...this.state,
            isActive: !this.state.isActive,
            menuPosition: this.getMenuPosition(e.currentTarget as HTMLElement)
        })
    }

    handleMenuClose() {
        this.setState({
            ...this.state,
            isActive: false,
            menuPosition: undefined
        })
    }

    renderMenu() {
        if (!this.state.isActive) return null;

        const menu = (
            <OverflowMenu className={overflowMenuStyle}
                onClose={this.handleMenuClose.bind(this)}
                onOptionSelected={(l, e) => this.props.onOptionSelected(l, e)}
                options={this.props.options}
                style={this.state.menuPosition}>
                {this.props.children}
            </OverflowMenu>
        );

        return typeof document !== 'undefined'
            ? ReactDOM.createPortal(menu, document.body)
            : menu;
    }

    render() {
        return (
            <div className={`${containerStyle} ${this.props.className ?? ''}`}>
                <Tooltip mouseEnterDelay={.5} overlayClassName={tooltipContentStyle} trigger={['hover']} placement="top" overlay={<span>Show options</span>}>
                    {this.props.icon ? <img className="menu-icon" src={this.props.icon} onClick={this.handleClick.bind(this)} />
                        : <div className={`${overflowButtonStyle} ${this.state.isActive ? 'active' : ''}`} onClick={this.handleClick.bind(this)}>
                            <div className="circle"></div>
                            <div className="circle"></div>
                            <div className="circle"></div>
                        </div>
                    }
                </Tooltip>
                {this.renderMenu()}
            </div>
        )
    }
}

const overflowMenuStyle = css`
    margin-left: 0;
    margin-top: 0;
    .triangle {
        margin-right: 13px;
    }
`;
const overflowButtonStyle = css`
    border: 1px solid ${color_shades_dark};
    border-radius: 50%;
    width: 30px;
    height: 30px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content:center;
    cursor: pointer;
    .circle {
        width: 4px;
        height: 4px;
        border-radius: 50%;
        border: solid 1px ${color_shades_dark};
        margin: 2px;
    }

    &:hover, &.active { 
        box-shadow: -1px 4px 10px 0 rgba(48, 69, 98, 0.1);
        border: solid 1px #007dbb;
        .circle {
            border: solid 1px #007dbb;
        }
    }

    &.active {
        background-color: rgba(0, 125, 187, 0.1);
    }
`;


const tooltipContentStyle = css`
    .rc-tooltip-inner{
        font-family: Muli;
        font-size: 14px;
        font-weight: normal;
        font-style: normal;
        letter-spacing: 0.6px;
        z-index: 120;
        color: white;
        background-color: #304562;
        box-shadow: -1px 4px 10px 0 rgba(48, 69, 98, 0.1);
        padding: 8px;
        min-height: 0;
    }
`
export default LargeOverflowMenu;